const templateUrl = require('./sent-shipment-list.html');

const app = angular.module('msi.shipments.sentShipmentList', []);

app.component('ogSentShipmentList', {
  bindings: {
    shipments: '=ogFor'
  },
  templateUrl: templateUrl
});

module.exports = app.name;
